export enum SocketState {
    None,
    Connected,
    Error,
    Disconnected,
}
